import { useMemo } from "react";
import { getRoles } from "../../services/silentAuth";

function useHasRole(role: string): boolean {
  const roles = getRoles();
  return useMemo(() => (!roles ? false : roles?.find((v) => v === role) !== undefined), [roles]);
}

export function useHasAnyRole(roles: string[]): boolean {
  const r = getRoles();
  return useMemo(() => (!r ? false : roles.find((w) => r?.find((v) => v === w) !== undefined) !== undefined), [r]);
}

export default useHasRole;
